import {
  ADMIN_PANEL_SECTION_CONFIG_FE_KEYS,
  ADMIN_PANEL_SECTION_CONFIG_FE_STATUS,
} from "features/AdminPanel/constants/AdminPanel.constants";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";

export const useSavingStatus = (customStore) => {
  const getSectionConfig = (state) => state.sectionConfig;
  const getSetSectionConfig = (state) => state.setSectionConfig;

  const useCustomStore = customStore ?? useAdminPanelStore;

  // @dev we are making use of the same hook for handling saving status, since flow is same only the store differs

  const sectionConfig = useCustomStore(getSectionConfig);
  const setSectionConfig = useCustomStore(getSetSectionConfig);

  const setSaving = ({ featureKey }) => {
    setSectionConfig({
      [featureKey]: {
        ...sectionConfig[featureKey],
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: {
          [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.UPDATION_STATUS]: {
            [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.STATUS]:
              ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVING,
          },
        },
      },
    });
  };

  const setSaved = ({ featureKey }) => {
    setSectionConfig({
      [featureKey]: {
        ...sectionConfig[featureKey],
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: {
          [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.UPDATION_STATUS]: {
            [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.STATUS]:
              ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.SAVED,
          },
        },
      },
    });
  };

  const setErrorStatus = ({ featureKey }) => {
    setSectionConfig({
      [featureKey]: {
        ...sectionConfig[featureKey],
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: {
          [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.UPDATION_STATUS]: {
            [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.STATUS]:
              ADMIN_PANEL_SECTION_CONFIG_FE_STATUS.ERROR,
          },
        },
      },
    });
  };

  const hideStatus = ({ featureKey }) => {
    setSectionConfig({
      [featureKey]: {
        ...sectionConfig[featureKey],
        [ADMIN_PANEL_SECTION_CONFIG_FE_KEYS.FE_METADATA]: undefined,
      },
    });
  };

  return { setSaving, setSaved, setErrorStatus, hideStatus };
};
